import { ValueOf } from '@app/types';

/**
 * Whether @see value is one of @see object's own values.
 *
 * @warning TypeScript gives numeric enums reverse mappings which make keys return true in addition to values.
 */
export function isValueOf<T extends Record<string, unknown>>(
  object: T,
  value: unknown
): value is ValueOf<T> {
  return Object.values(object).includes(value);
}
